import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { getContractsBalance } from '../../../selectors/contracts.selectors';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { LoadContractPaymentTermAction } from '../../../actions/contracts.actions';

@Injectable()
export class SetPaymentTermCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup): void {
    if (value) {
      this.store
        .select(getContractsBalance)
        .pipe()
        .subscribe((contractsBalance) => {
          const contractBalance = contractsBalance[value];
          if (!!contractBalance && contractBalance.length) {
            this.store.dispatch(
              new LoadContractPaymentTermAction([
                {
                  paymentTermCode: contractBalance[0].paymentTermCode,
                  paymentTermDesc: contractBalance[0].paymentTermDesc,
                },
              ]),
            );
          }
        });
    }
  }
}
